import React, { Component } from 'react';
import { Singleton } from '../js/Singleton';
import { btn1FooterSVG, powered, integrationIcon } from '../Images/FooterSVG'
import Integration from './workSpace/floatingWindows/Integration';
import About from './workSpace/floatingWindows/About';

export default class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      jsIntegrationActive: false,
      socketBoxIntegrationActive: false,
      aboutActive: false
    };
    this.timmerName = null;
    this.language = new Singleton();
    this.firstLoad = true;
  }

  componentWillReceiveProps(next_props) {
    if (!this.props.isLogged && this.props.integrationAutorun !== next_props.integrationAutorun) {
      this.setState({
        jsIntegrationActive: this.props.integrationAutorun,
        isActive: this.props.integrationAutorun
      });
    }
  }

  onClickBtnDeploy = () => {
    this.setState({ isActive: !this.state.isActive, jsIntegrationActive: false, aboutActive: false });
  }

  onClickBtnFooter = () => {
    this.setState({ jsIntegrationActive: false, aboutActive: !this.state.aboutActive });
  }

  onCloseAboutWindow = () => {
    this.setState({ aboutActive: false })
  }

  render() {
    return (
      <footer className={"footer " + (!this.props.isLogged ? "black" : "")}>
        <div className={'btnDeploy ' + (!this.props.isLogged ? "white" : "")} onClick={this.onClickBtnDeploy}>
          <div className={"squareFooter " + (!this.props.isLogged ? "white" : "")}></div>
          <div className={"squareFooter " + (this.state.isActive ? "active " : "hide ") + (!this.props.isLogged ? "white" : "")}></div>
          <div className={"squareFooter " + (!this.props.isLogged ? "white" : "")}></div>
          <div className={"squareFooter " + (!this.props.isLogged ? "white" : "")}></div>
        </div>
        <div className={"btnsInfobar " + (this.state.isActive ? 'is-deployedBar' : 'menu-hiddenBar')}></div>

        <div className={"btnsInfo " + (this.state.isActive ? (this.props.integrationIconActived ? ' is-deployed ' : ' is-deployedNoIntegration ') : this.props.integrationIconActived ? ' menu-hidden ' : ' menu-hiddenNoIntegration ')} >
          <div className="btnsContainer">
            <div className="footerContainer deploy ">
              <div className={"btnFooter " + (!this.props.isLogged ? "white" : "")} onClick={this.onClickBtnFooter}>{btn1FooterSVG}</div>
              {(this.state.aboutActive && this.state.isActive) ?
                <About closeAboutWindow={this.onCloseAboutWindow} /> : ""}
            </div>
            <div className={"footerContainer " + (this.props.integrationIconActived ? "deploy " : "")}>
              <div className={this.state.jsIntegrationActive ? "d-block" : "d-none"}>
                {
                  <Integration
                    IsIntegrationActive={this.state.jsIntegrationActive}
                    buttonConnectTop={false}
                    closeSocketBoxIntegration={() => this.setState({ jsIntegrationActive: false })}
                    titleIntegration={this.language.getText("GUIIntegrationtitle")}
                    integrationAutorun={this.props.integrationAutorun}
                  />}
              </div>
              <div className={"btnFooter " + (this.props.integrationIconActived ? "" : "undeploy ") + (!this.props.isLogged ? "white" : "")} onClick={() => this.setState({ aboutActive: false, jsIntegrationActive: !this.state.jsIntegrationActive })}>{integrationIcon}</div>
            </div>
          </div>
        </div>
        <div className={"imgDiv " + (!this.props.isLogged ? "white" : "")}> {powered} </div>
        <p className={"txtCopyright " + (this.state.isActive ? (this.props.integrationIconActived ? ' activeCopy ' : ' activeCopyNoIntegration ') : (this.props.integrationIconActived ? ' inActiveCopy ' : ' inActiveCopyNoIntegration ')) + (!this.props.isLogged ? "white" : "")}>{this.language.getText("GUILogingalateaCopyright")}</p>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer.jsx